<template>
    <div v-if="show" class="calendar_container">
        <div class="title_close">
            <h3 style="color: var(--titulo)">{{title}}:</h3>
            
            
            <div style="display: flex; gap: 1rem;">
                <AppButton v-bind:visibility="true" style="background-color: var(--button); color: var(--label);" text="Salvar" emitType="select" @select="saveDate" :width=20 :height=20 />

                <AppButton v-bind:visibility="mode != 'feriado'" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @close="close" :width=20 :height=20 />
            </div>
        </div>
        <div class="component_container" :key="holidayCopyKey">
            <DatePicker :initial-page="{ month: 1, year: 2024 }" :rows="3" :columns="4"  :attributes="calendarAttributes" class="custom-date-picker" @dayclick="onClick" color="red"/>
            <div v-if="showPopUp" class="popup_container" :style="popupStyle">
                <div>Descrição</div>
                <div>
                    <input v-model="current_description" type="text" style="border-radius: 0.5rem; padding:0.2rem; max-width: 170px;">
                </div>
                <div style="display: flex; gap: 1rem;">
                    <button class="btn" @click="update_date">adicionar</button>
                    <button class="btn" style="background-color: red;" @click="disablePopup">cancelar</button>
                </div>
            </div>
        </div>
        <div class="empty_space"></div>
    </div>
</template>


<script setup>
    import { ref, watch, computed, } from 'vue';
    import { DatePicker } from 'v-calendar';

    let showPopUp = ref(false);
    let clickPosition = ref({ x: 0, y: 0 });
    let current_description = ref('');
    const current_date = ref({});

    const popupStyle = computed(() => ({
        left: `${clickPosition.value.x}px`,
        top: `${clickPosition.value.y}px`,
    }));

    const holidayCopyKey = computed(() => JSON.stringify(holidays_copy.value));

    // Define props
    const props = defineProps({
        show: Boolean,
        title: String,
        mode: {
            type: String,
            default: () => 'assiduidade',
        },
        absences: {
            type: Array,
            default: () => [],
        },
        holidays: {
            type: Array,
            default: () => [],
        },
    });

    const absences_copy = ref(props.absences);
    const holidays_copy = ref([...props.holidays]);

    watch(() => props.absences, (newAbsences) => {
        absences_copy.value = [...newAbsences];
    });

    watch(() => props.holidays, (newHoliday) => {
        holidays_copy.value = [...newHoliday];
    });

    const abscence_attributes = ref(absences_copy.value.map((absenceObj) => {
        return {
            highlight: 'red',
            dates: new Date(absenceObj.data.replace(/-/g, '/')),
            popover: {
                label: absenceObj.descricao !== '' ? absenceObj.descricao : 'Sem Motivo',
            },
        };
    }));

    const holiday_attributes = ref(holidays_copy.value.map((holidayObj) => {
        return {
            highlight: 'red',
            dates: new Date(holidayObj.data.replace(/-/g, '/')),
            popover: {
                label: holidayObj.descricao !== '' ? holidayObj.descricao : 'Sem Descrição',
            },
        };
    }));

    const calendarAttributes = computed(() => {
        return props.mode === 'feriado' ? holiday_attributes.value : abscence_attributes.value;
    });

    const onClick = (clickedDate, event) => {
        if (props.mode !== 'feriado') return;

        current_description.value = '';
        showPopUp.value = true;
        current_date.value = clickedDate.date;

        const containerRect = event.target.closest('.component_container').getBoundingClientRect();
        clickPosition.value = { x: event.clientX - containerRect.left - 100, y: event.clientY - containerRect.top + 22 };

        holidays_copy.value.map((holidayObj) => {
            if (new Date(holidayObj.data.replace(/-/g, '/')).getTime() === clickedDate.date.getTime()) {
                current_description.value = holidayObj.descricao;
            }
        });
    };

    watch(() => absences_copy.value, (novoDates) => {
        abscence_attributes.value = novoDates.map((dateObj) => ({
            highlight: 'red',
            dates: new Date(dateObj.data.replace(/-/g, '/')),
            popover: {
                label: dateObj.descricao !== '' ? dateObj.descricao : 'Sem Motivo',
            },
        }));
    });

    watch(() => holidays_copy.value, (novoDates) => {
        holiday_attributes.value = novoDates.map((dateObj) => ({
            highlight: 'red',
            dates: new Date(dateObj.data.replace(/-/g, '/')),
            popover: {
                label: dateObj.descricao !== '' ? dateObj.descricao : 'Sem Motivo',
            },
        }));
    });

    const emit = defineEmits(['save']);

    const update_date = () => {
        const index = holidays_copy.value.findIndex(dateObj => new Date(dateObj.data.replace(/-/g, '/')).getTime() === current_date.value.getTime());

        if (index !== -1) {
            holidays_copy.value[index].descricao = current_description.value;
            holidays_copy.value[index].action = 'updated';
            holidays_copy.value = [...holidays_copy.value];
        } else {
            let new_date = {
                data: current_date.value.getFullYear() + '-' + (current_date.value.getMonth() + 1) + '-' + current_date.value.getDate(),
                descricao: current_description.value,
                id: 0,
                status: 'novo',
                action: 'novo'
            };
            holidays_copy.value = [...holidays_copy.value, new_date];
        }

        showPopUp.value = false;
    };

    const saveDate = () => {
        emit('save', holidays_copy.value);
    };

    const disablePopup = () => {
        showPopUp.value = false;
    };
</script>


<script>
    import AppButton from '@/components/updated/button.vue'

    export default {
        name: 'AppCalendario',

        components: {
            AppButton,
        },
        
        methods: {
            close() {
                this.$emit('close')
            },
            // saveDate(){
            //     console.log(this.range)
                
            //     this.$emit('save', this.range)
            // }
        }
    }
</script>

<style scoped>
    .calendar_container{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem;
        border-radius: 10px; 
        background-color: var(--fundoForm);
    }

    .custom-date-picker {
        width: 50px; 
        height: 50px;
    }

    .title_close{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 4rem;
    }

    .calendar_title {
        font-size: 16px;
        color: #ff9b05;
    }

    .component_container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative; /* Add this to ensure the popup positions correctly */
        overflow-y: auto;
    }

    .popup_container {
        width: 200px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        border-radius: 1rem;
        background-color: var(--fundoForm);
        color: var(--text);
        position: absolute; /* Use absolute positioning within the relative container */
        z-index: 100;
    }

    .empty_space {
        height: 100px;
    }
</style>
